<div [formGroup]="group" class="field" [ngClass]="{ hidden: field.hidden }">
    <p>
        <label for="{{ field.name }}-{{ formId }}" id="label-{{ field.name }}-{{ formId }}"
            >{{ field.label }}<span *ngIf="field.required" class="is-required">*</span></label
        >
        <ng-container *ngIf="field.description">
            <span class="hint">{{ field.description }}</span>
        </ng-container>
    </p>
    <ul class="reset">
        <ng-container *ngFor="let item of field.options; let i = index">
            <li>
                <label for="{{ field.name }}{{ i + 1 }}-{{ formId }}" class="radiolabel">
                    <input type="radio" id="{{ field.name }}{{ i + 1 }}-{{ formId }}" [value]="item.value" [formControlName]="field.name" />
                    <span class="radiolabelvalue">{{ item.label }}</span>
                </label>
            </li>
        </ng-container>
    </ul>
    <ng-container *ngIf="showErrors$ | async">
        <ng-container *ngFor="let error of group.get(field.name).errors | getIterableErrors">
            <span class="error-msg">{{ getErrorTranslation(error) }}</span>
        </ng-container>
    </ng-container>
    <ng-container *ngFor="let dependentField of field.dependentFieldFilters">
        <ng-container *ngIf="getVisibilityByDependentFieldFiltersAndSetValidators(dependentField, group.get(field.name))">
            <div class="row">
                <ng-container
                    daDynamicField
                    [control]="dependentField.dependentFormField"
                    [reactiveFormData]="group"
                    [formId]="formId"
                ></ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>
